import styled from '@emotion/styled';
import { IconButton } from '@mui/material';

export const HeaderContainer = styled.header`
  display: flex;
  width: 100%;
  padding: 2rem;
  align-items: space-between;
`;

export const AvatarButton = styled(IconButton)`
  margin-left: 2rem;
  padding: 0;
`;
